import type { ProductDetails } from '@/domains/shoppingCart/interfaces/ProductDetails';

export const getTrackingDate = () => {
  const now = new Date();
  const day = now.getDate().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');

  return `${day}${month}${now.getFullYear()}`;
};

export const countMfProducts = (products: ProductDetails[]) =>
  products.reduce(
    (acc, product) => (product.isMf ? acc + product.quantity : acc),
    0,
  );
